import script from "./SplitCollectionTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitCollectionTableRow.vue?vue&type=script&setup=true&lang=js"

import "./SplitCollectionTableRow.vue?vue&type=style&index=0&id=6913bb5b&lang=scss&scoped=true"
script.__scopeId = "data-v-6913bb5b"

export default script